import { ReactNode } from "react";

interface CanvasLayoutProps {
  children: ReactNode;
}

interface CanvasLayoutComponent {
  ({ children }: CanvasLayoutProps): React.JSX.Element;
  Main: ({ children }: { children: ReactNode }) => React.JSX.Element;
  Panel: ({ children }: { children: ReactNode }) => React.JSX.Element;
}

const CanvasLayout: CanvasLayoutComponent = ({ children }) => {
  return (
    <div className="h-screen bg-background flex flex-col md:flex-row">
      {children}
    </div>
  );
};

CanvasLayout.Main = ({ children }) => {
  return (
    <div className="flex-1 min-h-0 md:min-h-full md:min-w-0">
      {children}
    </div>
  );
};

CanvasLayout.Panel = ({ children }) => {
  return (
    <div className="h-64 md:h-auto md:w-80 md:min-w-80 md:max-w-80 md:flex-shrink-0 border-t md:border-t-0 md:border-l border-muted overflow-y-auto">
      {children}
    </div>
  );
};

export { CanvasLayout };